var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:'composition-api-example-no-component'},[_c('pre',[_c('code',{staticClass:"javascript",attrs:{"data-trim":"","data-noescape":"","data-line-numbers":"1-99"},domProps:{"innerHTML":_vm._s(_vm.exampleText)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }